import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { WellsComponent } from './wells.component';
import { WellDetailsComponent } from './well-details/well-details.component';
import { WellListComponent } from './well-list/well-list.component';
import { CompareMultipleWellComponent } from './compare-multiple-well/compare-multiple-well.component';
import { WellsCompareResolver } from './wells-compare.resolver';
import { TreatmentDetailsComponent } from './treatment-details/treatment-details.component';
import { DataFilesComponent } from './data-files/data-files.component';

const routes: Routes = [{
  path: '',
  component: WellsComponent,
  children: [
    {
      path: '',
      component: WellListComponent,
    },
    {
      path: 'compare',
      component: CompareMultipleWellComponent,
      resolve: { compareData: WellsCompareResolver }
    },
    {
      path: 'dataFiles',
      component: DataFilesComponent,
    },
    {
      path: ':id',
      component: WellDetailsComponent,
    },
    {
      path: 'treatmentDetails/:id',
      component: TreatmentDetailsComponent,
    },
    {
      path: '',
      redirectTo: '',
      pathMatch: 'prefix',
    },
  ],
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WellsRoutingModule {
}
